﻿﻿import { ITicketGroupUserRequest } from './ticket-group-user-request';

export interface ITicketGroupUsersRequest {
    groupId: number;
    users: ITicketGroupUserRequest[];
}
